import React from 'react'
import PropTypes from 'prop-types'
import { Trans, useTranslation } from 'gatsby-plugin-react-i18next'
import FAQItems from '../FAQItems'
import { CA_FRAME_FAQ_QUESTIONS, ENGLISH_FAQ_QUESTIONS, USA_FAQ_QUESTIONS } from './constants.js'
import { PLUS_FAQ_QUESTIONS } from '../../templates/PlusProductPage/constants'
import { CAL_FAQ_QUESTIONS } from './cal-constants.js'
import { UNIFIED_FAQ_QUESTIONS } from './unified-constants'

import { Section, ContentContainer } from '../FAQs/styles'
import { CAL_PRODUCT_PAGE_FAQ_QUESTIONS } from '../../templates/FrameProductPage/cal-constants'
import { BUDDY_FAQ_QUESTIONS } from '../../templates/BuddyProductPage/constants'
import { LOCALIZATION, IS_FOREIGN_COUNTRY } from '../../utils/constants'

const FAQSection = ({ page }) => {
  const { t } = useTranslation('common')

  // We need to omit some questions in CA & AU - so we're relying on a mix of translations in src/locales/en-ca/common.json and this mess of reduce functions to achieve the desired result -- it's probably just easier to duplicate the questions object
  const localizedCalMaxFAQs = IS_FOREIGN_COUNTRY
    ? CAL_PRODUCT_PAGE_FAQ_QUESTIONS?.reduce((allSections, section) => {
        if (section.sectionTitle === 'Calendar Max') {
          section.content = section.content.reduce((finalQs, item) => {
            if (item.q === "What's the difference between Classic and Shadow Box?") return finalQs // leave this one out in CA

            let localizedItem = item
            if (item.q === 'What are the different color and style options?') {
              // Struggled using translation functionality here due to \n in answer so changing the copy here instead
              localizedItem = {
                q: item.q,
                a: 'While we plan to expand our range of styles and colors in the near future, for now, we are only offering our Classic White Cal Max, which features a timeless and contemporary design for any home.',
              }
            }

            finalQs.push(localizedItem)
            return finalQs
          }, [])
        }
        allSections.push(section)
        return allSections
      }, [])
    : CAL_PRODUCT_PAGE_FAQ_QUESTIONS

  const QUESTION_OVERRIDES = {
    plus: PLUS_FAQ_QUESTIONS,
    calendar: CAL_FAQ_QUESTIONS,
    calendarProductPage: localizedCalMaxFAQs,
    buddyProductPage: BUDDY_FAQ_QUESTIONS,
    unified: UNIFIED_FAQ_QUESTIONS,
    calMax: localizedCalMaxFAQs,
    en: USA_FAQ_QUESTIONS,
    'en-ca': page === 'frame' ? CA_FRAME_FAQ_QUESTIONS : ENGLISH_FAQ_QUESTIONS,
    'en-au': ENGLISH_FAQ_QUESTIONS,
    'en-gb': ENGLISH_FAQ_QUESTIONS,
  }
  const questions = QUESTION_OVERRIDES[page] || QUESTION_OVERRIDES[LOCALIZATION]

  return (
    <ContentContainer page={page}>
      {questions.map((section, j) => (
        <React.Fragment key={j}>
          {section.sectionTitle && (
            <Section>
              <Trans>{section.sectionTitle}</Trans>
            </Section>
          )}
          {section.content.map((content, i) => (
            <FAQItems
              key={i + content.q}
              question={t(content.q)}
              answer={t(content.a)}
              text={t(content.text)}
              link={t(content.link)}
              punctuation={t(content.punctuation)}
              placement={content.placement}
              page={page}
            />
          ))}
        </React.Fragment>
      ))}
    </ContentContainer>
  )
}
FAQSection.propTypes = {
  page: PropTypes.string,
}
export default FAQSection
